export default "__VITE_ASSET__BNebM4lE__"